export function host(hostname) {
    switch (hostname) {
        case "localhost":
            return "https://krmsltst.emlakkatilim.com.tr";
        case "mortgagetest.emlakkatilim.com.tr":
            return "https://krmsltst.emlakkatilim.com.tr";
        case "www.emlakkatilim.com.tr":
            return "https://www.emlakkatilim.com.tr";
        default:
            return "https://www.emlakkatilim.com.tr";
    }
}